import React from 'react';
import { defineMessages, FormattedMessage } from '@kyruus/intl';
import { FacetList } from './facet-list';
import { StyledFacetPanel, StyledFacetListHeader } from '../styles';

const messages = defineMessages({
  facetlistheader: {
    id: 'facetlist.header',
    description: 'Header for a list of search results filters to apply',
    defaultMessage: 'Filters'
  }
});

export const FacetPanel = ({
  searchSummary,
  log,
  getUpdatedSearch,
  facets,
  distanceSort,
  showLocationFacet,
  config
}) => {
  return (
    <StyledFacetPanel className="facet-panel">
      <div className="filter-search-mobile">
        <StyledFacetListHeader>
          <FormattedMessage {...messages.facetlistheader} />
        </StyledFacetListHeader>
        <FacetList
          searchSummary={searchSummary}
          config={config}
          facets={facets}
          getUpdatedSearch={getUpdatedSearch}
          distanceSort={distanceSort}
          log={log}
          showLocationFacet={showLocationFacet}
        />
      </div>
    </StyledFacetPanel>
  );
};

FacetPanel.displayName = 'FacetPanel';
